import React from 'react';
import { observer } from 'mobx-react';

import { UiNavLink } from 'shared/uikit';
import { ROUTES } from 'shared/constants';

import { VmNotificationContentPropsType } from '../../types/VmNotificationContentPropsType';

type PropsType = VmNotificationContentPropsType;

export const VmNotificationEducationLessonRecent = observer(({ notification, onClose }: PropsType) => {
    let description = `Ближайшее мероприятие`;
    if (notification.data.educationLesson.name.toLowerCase().indexOf('курс англ') > -1) {
        description = `Ближайший курс английского`;
    } else if (notification.data.educationLesson.typeId === 'training') {
        description = `Ближайший тренинг`;
    } else if (notification.data.educationLesson.typeId === 'game') {
        description = `Ближайшая новая игра`;
    }

    return (
        <div className={'vm-notification__content'}>
            <div className={'vm-notification__name'}>Ближайшее событие</div>
            <div className='vm-notification__description'>
                {description} <UiNavLink to={ROUTES.EDUCATION() + `?educationLessonId=${notification.data.educationLesson.id}`} onClick={onClose}>{notification.data.educationLesson.name}</UiNavLink>
            </div>
            {!!notification.data.educationLesson.eventAt && (
                <div className='vm-notification__additional'>Дата: {notification.data.educationLesson.eventAtMoment.format('DD.MM.YYYY')}</div>
            )}
        </div>
    );
});
